import { Button } from "@/components/ui/button";
import { mainNav } from "@/config/nav";
import siteData from "@/config/siteData.json";
import { Link, useNavigate } from "react-router";
import { MobileDrawer } from "./mobile-drawer";

interface SiteNavProps {
  isLoggedIn?: boolean;
}

export function SiteNav({ isLoggedIn = false }: SiteNavProps) {
  const navigate = useNavigate();
  return (
    <header className="container z-40 flex h-20 items-center justify-between py-6">
      <div
        className="flex items-center space-x-2 cursor-pointer"
        onClick={() => navigate("/")}
      >
        <img
          src="/sendkit-logo.png"
          alt={`${siteData.name} logo`}
          className="h-12"
        />
        <span className="text-4xl font-bold">{siteData.name}</span>
      </div>
      <nav className="flex items-center space-x-6">
        <div className="hidden md:flex items-center space-x-6">
          {mainNav.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="text-sm font-medium hover:underline underline-offset-4"
            >
              {item.title}
            </Link>
          ))}
          <Button asChild>
            {!isLoggedIn ? (
              <Link to="/login">Get Started</Link>
            ) : (
              <Link to="/dashboard">Dashboard</Link>
            )}
          </Button>
        </div>
        <MobileDrawer isLoggedIn={isLoggedIn} />
      </nav>
    </header>
  );
}
